<template>
  <div class="mv-bg-main">
    <el-row>
      <el-col :span="24">
        <el-card shadow="always">
          <div slot="header" class="clearfix">
            <span>查询条件</span>
          </div>
          <el-form
            :inline="true"
            :model="formInline"
            ref="searchForm"
            label-width="100px"
            class="demo-form-inline"
          >
            <el-form-item label="业务系统" prop="sysId">
              <el-select
                v-model="formInline.sysId"
                placeholder="请选择业务系统"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称" >
              <el-select
                v-model="formInline.custId"
                :filter-method="filterPinYinMethod"
                placeholder="请选择客户名称"
                @clear="clearMatch"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in custSimpleInfoList"
                  :key="index"
                  :label="item.custName"
                  :value="item.custId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单名称" prop="cusOrder">
              <el-input v-model="formInline.cusOrder" placeholder="请输入订单名称"></el-input>
            </el-form-item>
            <el-form-item label="创建时间" prop="createTime">
              <el-date-picker
                v-model="formInline.createTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="float-r">
              <el-button size="small" @click="onReset('searchForm')">重置</el-button>
              <el-button size="small" type="primary" @click="onSearch()">查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <div style="margin-top:20px"></div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" shadow="always">
          <div slot="header" class="clearfix">
            <span>查询结果</span>
            <div class="mv-list-buttons float-r">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-plus"
                title="新增供应商合同"
                @click="handleAdd"
              ></el-button>
            </div>
          </div>
          <el-row>
            <el-table
              :data="tableList"
              :fit="true"
              style="width: 100%"
            >
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column prop="sysName" :show-overflow-tooltip="tooltip" label="业务系统"></el-table-column>
              <el-table-column prop="custName" :show-overflow-tooltip="tooltip" label="客户名称">
                <template slot-scope="scope">
                  <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.custName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="orderName" :show-overflow-tooltip="tooltip" label="订单名称"></el-table-column>
              <el-table-column prop="orderId" :show-overflow-tooltip="tooltip" label="订单编号"></el-table-column>
              <el-table-column prop="orderAmount" :show-overflow-tooltip="tooltip" label="订单总额(元)"></el-table-column>
              <el-table-column
                prop="profit"
                width="200"
                :show-overflow-tooltip="tooltip"
                label="利润总额(元)"
              ></el-table-column>
              <el-table-column prop="orderStatus" :show-overflow-tooltip="tooltip" label="状态">
                <template slot-scope="scope">{{ scope.row.orderStatus | dateFormat }}</template>
              </el-table-column>
              <el-table-column prop="createTime" :show-overflow-tooltip="tooltip" label="订单时间"></el-table-column>
              <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <div class="page-navigation">
            <el-pagination
              background
              :current-page.sync="page.num"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next"
              :total="totalRows"
              @size-change="pageSizeChange"
              @current-change="pageCurrentChange"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog  :title="title" @close="closeOrder" width="1150px" center :modal-append-to-body='false' :visible.sync="orderDialog">
      <el-form :model="orderInfo" :rules="rule" ref="orderInfo" label-width="120px" >
        <h2 class="refund-dialog-title">订单信息</h2>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单名称" prop="orderName">
              <el-input :disabled="allDisabled" style="width: 90%;" v-model="orderInfo.orderName" placeholder="请输入订单名称"></el-input>
            </el-form-item>
            <el-form-item label="订单状态" prop="orderState"   >
              <el-select :disabled="allDisabled" v-model="orderInfo.orderState" style="width: 90%;" placeholder="请选择订单状态" clearable>
                <el-option
                  label="未付款"
                  value="0"
                ></el-option>
                <el-option
                  label="已付款"
                  value="1"
                ></el-option>
                <el-option
                  label="已完结"
                  value="2"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付渠道" prop="payChannelCode">
              <el-select style="width: 90%;" :disabled="allDisabled" v-model="orderInfo.payChannelCode" placeholder="请选择支付渠道" clearable>
                <el-option
                  v-for="(item, index) in payChannelData"
                  :key="index"
                  :label="item.payChannelName"
                  :value="item.payChannelCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式" prop="payMethod"   >
              <el-select
                style="width: 90%;"
                v-model="orderInfo.payMethod"
                placeholder="请选择支付方式"
                :disabled="allDisabled"
                clearable
                filterable
              >
                <el-option
                  label="线上"
                  value="518266784689516512"
                ></el-option>
                <el-option
                  label="线下"
                  value="518266784689531331"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务系统" prop="sysId">
              <el-select
                v-model="orderInfo.sysId"
                style="width: 90%;"
                :disabled="allDisabled"
                placeholder="请选择业务系统"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称" prop="custName">
              <el-select
                style="width: 90%;"
                v-model="orderInfo.custName"
                :disabled="allDisabled"
                placeholder="请选择客户名称"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in custSimpleInfoList"
                  :key="index"
                  :label="item.custName"
                  :value="item.custId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单描述" prop="desc">
              <el-input type="textarea" :disabled="allDisabled" style="width: 90%;" maxlength="150" placeholder="订单描述" v-model="orderInfo.desc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <h2 class="refund-dialog-title">产品信息</h2>
        <el-form-item
          label="新增产品信息">
          <el-button
            size="small"
            :disabled="allDisabled"
            type="primary"
            icon="el-icon-plus"
            style="margin-left: 10px;"
            title="新增产品信息"
            plain
            @click="addExtField"
          ></el-button>
        </el-form-item>
        <div class="clearfix" style="text-align: center;">
          <p style="float: left;width: 100px; margin-left: 20px; margin-bottom: 20px;">产品名称</p>
          <p style="float: left;width: 100px; margin-left: 20px;">成本</p>
          <p style="float: left;width: 100px; margin-left: 20px;">销售单价</p>
          <p style="float: left;width: 100px; margin-left: 20px;">成交数量</p>
          <p style="float: left;width: 100px; margin-left: 20px;">总价</p>
          <p style="float: left;width: 100px; margin-left: 20px;">折扣</p>
          <p style="float: left;width: 100px; margin-left: 41px;">实际成交价</p>
          <p style="float: left;width: 100px; margin-left: 20px;">利润</p>
        </div>
        <div
          v-for="(item, index) in orderInfo.extFieldList"
          class="clearfix"
          :key="index">
          <el-select
            style="float: left; width: 100px; margin-left: 20px;margin-bottom: 20px;"
            v-model="item.prodId"
            :disabled="allDisabled"
            @change="changePro(item.prodId, index)"
            placeholder="请选择产品名称"
            clearable
            filterable
          >
            <el-option
              v-for="(item, $index) in proData"
              :key="$index"
              :label="item.prodName"
              :value="item.prodId"
            ></el-option>
          </el-select>
          <!-- <el-input  v-model="item.prodId" placeholder></el-input> -->
          <el-input disabled style="float: left;width: 100px;margin-left: 20px;" v-model="item.cost" placeholder></el-input>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.salePrice"></el-input>
          <el-input-number :disabled="allDisabled" @change="addNum(item)" style="float: left;width: 100px; margin-left: 20px;" v-model="item.orderCount" controls-position="right"  :min="0" :max="item.max"></el-input-number>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.total" ></el-input>
          <el-input :disabled="allDisabled"  style="float: left;width: 100px; margin-left: 20px;" @input="changeDiscount(item)" oninput="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}"
            onpaste="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}" v-model="item.discount" ></el-input>
          <span
            style="float: left;width: 30px; margin-top: 10px; margin-left: 5px;"
          >%</span>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.actualPrice" ></el-input>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.proProfit" ></el-input>
          <el-button
              class="float-r"
              size="small"
              icon="el-icon-delete"
              :disabled="allDisabled"
              @click.prevent="removeExtField(item)"
              title="删除"
            ></el-button>
        </div>
        <div class="clearfix">
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            合计
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allCost}}
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allsalePrice}}
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allNum}}
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allTotal}}
          </div>
          <div style="float: left;width: 100px; margin-left: 160px; text-align: center;">
            {{allactualPrice}}
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allproProfit}}
          </div>
        </div>
        <el-row style="margin-top: 22px;">
          <el-col :span="12">
            <el-form-item label="折扣信息" prop="discount">
              <el-input :disabled="allDisabled" style="width: 90%;" oninput="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}"
            onpaste="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}" @input="againDiscount" v-model="discount" placeholder="请输入折扣信息"></el-input>
              <span>%</span>
            </el-form-item>
            <el-form-item label="总成本" prop="totalCost">
              <el-input style="width: 90%;" disabled v-model="totalCost" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="折扣后金额" prop="orderAmount">
              <el-input style="width: 90%;" disabled v-model="orderAmount" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="利润" prop="profit">
              <el-input style="width: 90%;" disabled v-model="profit" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="textAlign: center;" >
          <el-button @click="orderDialog=false">取 消</el-button>
          <el-button type="primary"  @click="orderSave('orderInfo')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog  title="订单详情" @close="closeDetailOrder" width="1150px" center :modal-append-to-body='false' :visible.sync="orderDetailDialog">
      <el-form :model="orderDetailInfo"  ref="orderDetailInfo" label-width="120px" >
        <h2 class="refund-dialog-title">订单信息</h2>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单名称" prop="orderName">
              <el-input disabled style="width: 90%;" v-model="orderDetailInfo.orderName" placeholder="请输入订单名称"></el-input>
            </el-form-item>
            <el-form-item label="订单状态" prop="orderState"   >
              <el-select disabled v-model="orderDetailInfo.orderState" style="width: 90%;" placeholder="请选择订单状态" clearable>
                <el-option
                  label="未付款"
                  value="0"
                ></el-option>
                <el-option
                  label="已付款"
                  value="1"
                ></el-option>
                <el-option
                  label="已完结"
                  value="2"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付渠道" prop="payChannelCode">
              <el-select disabled style="width: 90%;" v-model="orderDetailInfo.payChannelCode" placeholder="请选择支付渠道" clearable>
                <el-option
                  v-for="(item, index) in payChannelData"
                  :key="index"
                  :label="item.payChannelName"
                  :value="item.payChannelCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式" prop="payMethod"   >
              <el-select
                disabled
                style="width: 90%;"
                v-model="orderDetailInfo.payMethod"
                placeholder="请选择支付方式"
                clearable
                filterable
              >
                <el-option
                  label="线上"
                  value="518266784689516512"
                ></el-option>
                <el-option
                  label="线下"
                  value="518266784689531331"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务系统" prop="sysId">
              <el-select
                v-model="orderDetailInfo.sysId"
                style="width: 90%;"
                placeholder="请选择业务系统"
                clearable
                disabled
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称" prop="custName">
              <el-select
                style="width: 90%;"
                v-model="orderDetailInfo.custName"
                placeholder="请选择客户名称"
                disabled
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in custSimpleInfoList"
                  :key="index"
                  :label="item.custName"
                  :value="item.custId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单描述" prop="desc">
              <el-input type="textarea" disabled style="width: 90%;" maxlength="150" placeholder="订单描述" v-model="orderDetailInfo.desc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <h2 class="refund-dialog-title">产品信息</h2>
        <div class="clearfix" style="text-align: center;">
          <p style="float: left;width: 100px; margin-left: 20px; margin-bottom: 20px;">产品名称</p>
          <p style="float: left;width: 100px; margin-left: 20px;">成本</p>
          <p style="float: left;width: 100px; margin-left: 20px;">销售单价</p>
          <p style="float: left;width: 100px; margin-left: 20px;">成交数量</p>
          <p style="float: left;width: 100px; margin-left: 20px;">总价</p>
          <p style="float: left;width: 100px; margin-left: 20px;">折扣</p>
          <p style="float: left;width: 100px; margin-left: 41px;">实际成交价</p>
          <p style="float: left;width: 100px; margin-left: 20px;">利润</p>
        </div>
        <div
          v-for="(item, index) in orderDetailInfo.extFieldList"
          class="clearfix"
          :key="index">
          <el-select
            style="float: left; width: 100px; margin-left: 20px;margin-bottom: 20px;"
            v-model="item.prodId"
            disabled
            @change="changePro(item.prodId, index)"
            placeholder="请选择产品名称"
            clearable
            filterable
          >
            <el-option
              v-for="(item, $index) in proData"
              :key="$index"
              :label="item.prodName"
              :value="item.prodId"
            ></el-option>
          </el-select>
          <!-- <el-input  v-model="item.prodId" placeholder></el-input> -->
          <el-input disabled style="float: left;width: 100px;margin-left: 20px;" v-model="item.cost" placeholder></el-input>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.salePrice"></el-input>
          <el-input-number disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.orderCount" controls-position="right"  :min="0" :max="item.max"></el-input-number>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.total" ></el-input>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;"  oninput="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}"
            onpaste="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}" v-model="item.discount" ></el-input>
          <span
            style="float: left;width: 30px; margin-top: 10px; margin-left: 5px;"
          >%</span>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.actualPrice" ></el-input>
          <el-input disabled style="float: left;width: 100px; margin-left: 20px;" v-model="item.proProfit" ></el-input>
          <!-- <el-button
              class="float-r"
              size="small"
              icon="el-icon-delete"
              @click.prevent="removeExtField(item)"
              title="删除"
            ></el-button> -->
        </div>
        <!-- <div class="clearfix">
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            合计
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allCost}}
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allsalePrice}}
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allNum}}
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allTotal}}
          </div>
          <div style="float: left;width: 100px; margin-left: 160px; text-align: center;">
            {{allactualPrice}}
          </div>
          <div style="float: left;width: 100px; margin-left: 20px; text-align: center;">
            {{allproProfit}}
          </div>
        </div> -->
        <el-row style="margin-top: 22px;">
          <el-col :span="12">
            <el-form-item label="折扣信息" prop="discount">
              <el-input style="width: 90%;" oninput="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}"
            onpaste="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}" disabled v-model="orderDetailInfo.discount" placeholder="请输入折扣信息"></el-input>
              <span>%</span>
            </el-form-item>
            <el-form-item label="总成本" prop="totalCost">
              <el-input style="width: 90%;" disabled v-model="orderDetailInfo.totalCost" placeholder="请输入总成本"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="折扣后金额" prop="orderAmount">
              <el-input style="width: 90%;" disabled v-model="orderDetailInfo.orderAmount" placeholder="请输入折扣后金额"></el-input>
            </el-form-item>
            <el-form-item label="利润" prop="profit">
              <el-input style="width: 90%;" disabled v-model="orderDetailInfo.profit" placeholder="请输入利润"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script >
export default {
  name: 'cusOrder',
  data () {
    return {
      formInline: {
        sysId: '',
        custId: '',
        cusOrder: '',
        createTime: ''
      },
      orderDetailDialog: false,
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      payChannelData: [],
      uploadFile: this.$API.fileUpload,
      orderDialog: false,
      tableList: [],
      title: '',
      allCost: '',
      allsalePrice: '',
      allNum: '',
      allTotal: '',
      allactualPrice: '',
      allproProfit: '',
      discount: 100,
      orderAmount: '',
      totalCost: '',
      profit: '',
      orderDetailInfo: {
        sysId: '',
        orderName: '',
        orderId: '',
        orderState: '',
        payChannelCode: '',
        paymentName: '',
        payMethod: '',
        custName: '',
        desc: '',
        extFieldList: [
          {
            prodId: '', // 产品id
            refId: '',
            cost: '', // 成本
            salePrice: '', // 单价
            orderCount: '', // 成交数量
            total: '', // 总价
            max: 0,
            actualPrice: '', // 实际成交价
            proProfit: '', // 利润
            discount: 100 // 折扣
          }
        ],
        paymentAmount: '',
        orderFiles: [],
        companyorderor: '',
        discount: 100,
        orderAmount: '',
        totalCost: '',
        profit: ''
      },
      orderInfo: {
        sysId: '',
        orderName: '',
        orderId: '',
        orderState: '',
        payChannelCode: '',
        paymentName: '',
        payMethod: '',
        custName: '',
        desc: '',
        extFieldList: [
          {
            prodId: '', // 产品id
            cost: '', // 成本
            refId: '',
            salePrice: '', // 单价
            orderCount: '', // 成交数量
            total: '', // 总价
            max: 0,
            actualPrice: '', // 实际成交价
            proProfit: '', // 利润
            discount: 100 // 折扣
          }
        ],
        paymentAmount: '',
        orderFiles: [],
        companyorderor: ''
      },
      rule: {
        orderName: [
          {
            required: true,
            message: '请输入订单名称',
            trigger: ['blur', 'change']
          }
        ],
        sysId: [
          {
            required: true,
            message: '请选择业务系统',
            trigger: ['blur', 'change']
          }
        ],
        orderState: [
          {
            required: true,
            message: '请选择订单状态',
            trigger: ['blur', 'change']
          }
        ],
        payChannelCode: [
          {
            required: true,
            message: '请选择支付渠道',
            trigger: ['blur', 'change']
          }
        ],
        payMethod: [
          {
            required: true,
            message: '请选择支付方式',
            trigger: ['blur', 'change']
          }
        ],
        custName: [
          {
            required: true,
            message: '请选择客户名称',
            trigger: ['blur', 'change']
          }
        ]
      },
      custSimpleInfoList: [], // 客户名称列表
      custCopeSimpleInfoList: [], // 拼音客户名称列表
      activeName: '',
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      tooltip: true,
      allDisabled: false,
      totalRows: 0,
      conData: [],
      proData: []
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  filters: {
    dateFormat (val) {
      return val === '0' ? '未付款' : val === '1' ? '已付款' : '已完结'
    }
  },
  methods: {
    /* 重置操作 */
    onReset (formName) {
      this.formInline = {
        sysId: '',
        custId: '',
        cusOrder: '',
        createTime: ''
      }
      this.custSimpleInfoList = this.custCopeSimpleInfoList
      this.$refs[formName].resetFields()
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.sizeSmall = val
      this.page.num = 1
      this.query()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.query()
    },
    changePro (val, index) {
      // for (let)
      console.log(val)
      if (!val) {
        this.orderInfo.extFieldList[index].cost = ''
        this.orderInfo.extFieldList[index].salePrice = ''
        this.orderInfo.extFieldList[index].orderCount = 1
        this.orderInfo.extFieldList[index].max = 1
        this.calculation()
        return
      }
      for (let v of this.proData) {
        if (val === v.prodId) {
          this.orderInfo.extFieldList[index].cost = Number(v.cost)
          this.orderInfo.extFieldList[index].salePrice = Number(v.price)
          this.orderInfo.extFieldList[index].orderCount = 1
          this.orderInfo.extFieldList[index].max = Number(v.stock)
          this.calculation()
        }
      }
      console.log(index)
    },
    againDiscount () {
      this.calculation()
    },
    calculation () {
      let allCost = 0
      let allsalePrice = 0
      let allNum = 0
      let allTotal = 0
      let allactualPrice = 0
      let allproProfit = 0
      let cost = 0
      for (let v of this.orderInfo.extFieldList) {
        allCost += Number(v.cost)
        allsalePrice += Number(v.salePrice)
        allNum += Number(v.orderCount)
        v.total = Number(Number(v.salePrice) * Number(v.orderCount)).toFixed(2)
        if (v.discount || v.discount === 0 || v.discount === '0') {
          v.actualPrice = Number((v.discount / 100) * v.total).toFixed(2)
          v.proProfit = Number(v.actualPrice - (Number(v.cost) * Number(v.orderCount))).toFixed(2)
          console.log('sss')
        } else {
          console.log('ss')
          v.actualPrice = v.total.toFixed(2)
          v.proProfit = Number(v.actualPrice - (Number(v.cost) * Number(v.orderCount))).toFixed(2)
        }
        allTotal += Number(v.total)
        allactualPrice += Number(v.actualPrice)
        allproProfit += Number(v.proProfit)
        cost += Number(v.cost) * Number(v.orderCount)
      }
      for (let v of this.orderDetailInfo.extFieldList) {
        v.total = Number(Number(v.salePrice) * Number(v.orderCount)).toFixed(2)
        if (v.discount || v.discount === 0 || v.discount === '0') {
          v.actualPrice = Number((v.discount / 100) * v.total).toFixed(2)
          v.proProfit = Number(v.actualPrice - (Number(v.cost) * Number(v.orderCount))).toFixed(2)
          console.log('sss')
        } else {
          console.log('ss')
          v.actualPrice = v.total.toFixed(2)
          v.proProfit = Number(v.actualPrice - (Number(v.cost) * Number(v.orderCount))).toFixed(2)
        }
      }
      this.allCost = allCost.toFixed(2)
      this.allsalePrice = allsalePrice.toFixed(2)
      this.allNum = allNum
      this.allTotal = allTotal.toFixed(2)
      this.allactualPrice = allactualPrice.toFixed(2)
      this.allproProfit = allproProfit.toFixed(2)
      this.totalCost = Number(cost).toFixed(2)
      if (this.discount && this.discount !== 0) {
        this.orderAmount = Number((this.discount / 100) * this.allactualPrice).toFixed(2)
      } else {
        this.orderAmount = Number(this.allactualPrice).toFixed(2)
      }
      this.profit = Number(this.orderAmount - this.totalCost).toFixed(2)
    },
    addNum (item) {
      console.log(item)
      // let total = (Number(item.cost) + Number(item.salePrice)) * item.orderCount
      // item.total = total
      // if (item.discount && item.discount !== 0) {
      //   item.actualPrice = Number((item.discount / 100) * item.total)
      //   item.proProfit = Number(item.actualPrice - (Number(item.salePrice) * Number(item.orderCount)))
      // } else {
      //   item.actualPrice = item.total
      //   item.proProfit = Number(item.actualPrice - (Number(item.salePrice) * Number(item.orderCount)))
      // }
      this.calculation()
    },
    changeDiscount (item) {
      // console.log(item)
      // if (item.discount && item.discount !== 0) {
      //   item.actualPrice = Number((item.discount / 100) * item.total)
      //   item.proProfit = Number(item.actualPrice - (Number(item.salePrice) * Number(item.orderCount)))
      // } else {
      //   item.actualPrice = item.total
      //   item.proProfit = Number(item.actualPrice - (Number(item.salePrice) * Number(item.orderCount)))
      // }
      this.calculation()
    },
    detail (index, val) {
      let op = {}
      op.orderId = val.orderId
      let _this = this
      this.$axios({
        method: 'post',
        url: _this.$API.customerManagement.queryCustOrderById,
        // url: 'http://172.16.9.104:5010/agw/orderCustCtr/queryCustOrderById',
        data: op
      }).then((response) => {
        let data = response.data.resData
        _this.orderDetailInfo.sysId = Number(data.sysId)
        _this.orderDetailInfo.custName = data.custId
        _this.orderDetailInfo.orderId = data.orderId
        _this.orderDetailInfo.orderName = data.orderName
        _this.orderDetailInfo.orderState = data.orderStatus
        _this.orderDetailInfo.payMethod = data.payModeCode
        _this.orderDetailInfo.payChannelCode = data.payChannelCode
        _this.orderDetailInfo.desc = data.orderDesc
        _this.orderDetailInfo.extFieldList = data.prodList
        _this.calculation()
        _this.orderDetailInfo.discount = data.discount
        _this.orderDetailInfo.orderAmount = data.orderAmount
        _this.orderDetailInfo.totalCost = data.totalCost
        _this.orderDetailInfo.profit = data.profit
      }).catch((err) => {
        console.log(err)
      })
      this.orderDetailDialog = true
    },
    handleEdit (index, val) {
      let op = {}
      op.orderId = val.orderId
      let _this = this
      this.$axios({
        method: 'post',
        url: _this.$API.customerManagement.queryCustOrderById,
        // url: 'http://172.16.9.104:5010/agw/orderCustCtr/queryCustOrderById',
        data: op
      }).then((response) => {
        let data = response.data.resData
        _this.orderInfo.sysId = Number(data.sysId)
        _this.orderInfo.custName = data.custId
        _this.orderInfo.orderId = data.orderId
        _this.orderInfo.orderName = data.orderName
        _this.orderInfo.orderState = data.orderStatus
        if (data.orderStatus === '2') {
          _this.allDisabled = true
        }
        _this.orderInfo.payMethod = data.payModeCode
        _this.orderInfo.payChannelCode = data.payChannelCode
        _this.orderInfo.desc = data.orderDesc
        _this.orderInfo.extFieldList = data.prodList
        _this.calculation()
        _this.discount = data.discount
        _this.orderAmount = data.orderAmount
        _this.totalCost = data.totalCost
        _this.profit = data.profit
      }).catch((err) => {
        console.log(err)
      })
      this.orderDialog = true
      this.title = '编辑客户订单'
    },
    orderStateChange (val) {
      if (val === '2' && this.title === '编辑客户订单') {
        this.allDisabled = true
      }
    },
    orderSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title === '编辑客户订单') {
            let op = {}
            let id = this.orderInfo.sysId
            let sysIds = []
            if (id && id !== 0) {
              sysIds.push(id)
            }
            op.sysIds = sysIds
            op.orderId = this.orderInfo.orderId
            op.custId = this.orderInfo.custName
            op.orderName = this.orderInfo.orderName
            op.orderStatus = this.orderInfo.orderState
            op.payModeCode = this.orderInfo.payMethod
            op.payChannelCode = this.orderInfo.payChannelCode
            op.orderDesc = this.orderInfo.desc
            op.prodList = this.orderInfo.extFieldList.concat()
            op.orderAmount = Number(this.orderAmount)
            op.discount = Number(this.discount)
            op.totalCost = Number(this.totalCost)
            op.profit = Number(this.profit)
            for (let i = 0; i < op.prodList.length; i++) {
              if (op.prodList[i] && op.prodList[i + 1] && op.prodList[i].prodId === op.prodList[i + 1].prodId) {
                _this.$message.error('产品不能重复!')
                return
              }
              if (!op.prodList[i].prodId) {
                op.prodList.splice(i, 1)
              }
            }
            for (let v of op.prodList) {
              v.cost = Number(v.cost)
              v.salePrice = Number(v.salePrice)
              v.orderCount = Number(v.orderCount)
              v.discount = Number(v.discount)
            }
            this.$axios({
              method: 'post',
              url: _this.$API.customerManagement.updateCustOrder,
              // url: 'http://172.16.9.104:5010/agw/orderCustCtr/addCustOrder',
              data: op
            }).then((response) => {
              _this.$message.success('订单编辑成功!')
              _this.orderDialog = false
              _this.query()
            }).catch((err) => {
              console.log(err)
            })
          } else {
            let op = {}
            let id = this.orderInfo.sysId
            let sysIds = []
            if (id && id !== 0) {
              sysIds.push(id)
            }
            op.sysIds = sysIds
            op.custId = this.orderInfo.custName
            op.orderName = this.orderInfo.orderName
            op.orderStatus = this.orderInfo.orderState
            op.payModeCode = this.orderInfo.payMethod
            op.payChannelCode = this.orderInfo.payChannelCode
            op.orderDesc = this.orderInfo.desc
            op.prodList = this.orderInfo.extFieldList.concat()
            op.orderAmount = Number(this.orderAmount)
            op.discount = Number(this.discount)
            op.totalCost = Number(this.totalCost)
            op.profit = Number(this.profit)
            for (let i = 0; i < op.prodList.length; i++) {
              if (op.prodList[i] && op.prodList[i + 1] && op.prodList[i].prodId === op.prodList[i + 1].prodId) {
                _this.$message.error('产品不能重复!')
                return
              }
              if (!op.prodList[i].prodId) {
                op.prodList.splice(i, 1)
              }
            }
            console.log(op.prodList)
            for (let v of op.prodList) {
              v.cost = Number(v.cost)
              v.salePrice = Number(v.salePrice)
              v.orderCount = Number(v.orderCount)
              v.discount = Number(v.discount)
            }
            this.$axios({
              method: 'post',
              url: _this.$API.customerManagement.addCustOrder,
              // url: 'http://172.16.9.104:5010/agw/orderCustCtr/addCustOrder',
              data: op
            }).then((response) => {
              _this.$message.success('订单新增成功!')
              _this.orderDialog = false
              _this.query()
            }).catch((err) => {
              console.log(err)
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /* 客户拼音搜索 */
    filterPinYinMethod (val) {
      const pinyinMatch = require('pinyin-match')
      if (val) {
        let result = []
        this.custCopeSimpleInfoList.forEach((v) => {
          let m = pinyinMatch.match(v.custName, val)
          if (m) {
            result.push(v)
          }
        })
        this.custSimpleInfoList = result
      } else {
        this.custSimpleInfoList = this.custCopeSimpleInfoList
      }
      this.formInline.custId = val
    },
    clearMatch () {
      this.custSimpleInfoList = this.custCopeSimpleInfoList
    },
    closeDetailOrder () {
      this.orderDetailInfo = {
        sysId: '',
        orderName: '',
        orderId: '',
        orderState: '',
        payChannelCode: '',
        paymentName: '',
        payMethod: '',
        custName: '',
        desc: '',
        extFieldList: [
          {
            prodId: '',
            refId: '',
            cost: '',
            salePrice: '',
            max: 0,
            orderCount: '',
            discount: 100
          }
        ],
        orderFiles: [],
        companyorderor: '',
        discount: 100,
        orderAmount: '',
        totalCost: '',
        profit: ''
      }
    },
    closeOrder () {
      this.orderInfo = {
        sysId: '',
        orderName: '',
        orderId: '',
        orderState: '',
        payChannelCode: '',
        paymentName: '',
        payMethod: '',
        custName: '',
        desc: '',
        extFieldList: [
          {
            prodId: '',
            cost: '',
            salePrice: '',
            max: 0,
            orderCount: '',
            refId: '',
            discount: 100
          }
        ],
        orderFiles: [],
        companyorderor: ''
      }
      this.allCost = ''
      this.allDisabled = false
      this.allsalePrice = ''
      this.allNum = ''
      this.allTotal = ''
      this.allactualPrice = ''
      this.allproProfit = ''
      this.discount = 100
      this.orderAmount = ''
      this.totalCost = ''
      this.profit = ''
      this.$refs['orderInfo'].resetFields()
      this.title = ''
      this.orderDialog = false
    },
    handleAdd () {
      this.orderDialog = true
      this.title = '新增客户订单'
    },
    orderInfoSave (formName) {
      /* 判断弹窗状态值, 编辑修改/新增保存 */
      let _this = this
      if (this.title === 'editMaintenance') {
        this.$refs[formName].validate(valid => {
          if (valid) {
          } else {
            _this.$message.error('请按规范填写输入框!')
            return false
          }
        })
      } else if (this.title === 'addMaintenance') {
        this.$refs[formName].validate(valid => {
          if (valid) {
          } else {
            _this.$message.error('请按规范填写输入框!')
            return false
          }
        })
      }
    },
    addExtField () {
      this.orderInfo.extFieldList.push({
        prodId: '',
        cost: '',
        refId: '',
        max: 0,
        salePrice: '',
        orderCount: '',
        total: '', // 总价
        actualPrice: '', // 实际成交价
        proProfit: '',
        discount: 100
      })
    },
    /* 删除扩展属性 */
    removeExtField (item) {
      var index = this.orderInfo.extFieldList.indexOf(item)
      if (index !== -1) {
        /* 对已存在的扩展属性删除push到另一个数组 */
        /* if (item.id) {
          item.isDelete = 1
          this.extFieldList2.push(item)
        } */
        this.orderInfo.extFieldList.splice(index, 1)
        this.calculation()
      }
    },
    onSearch () {
      this.page.num = 1
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.page.num
      op.pageSize = this.page.sizeSmall
      op.custId = this.formInline.custId
      op.sysIds = sysIds
      op.orderName = this.formInline.cusOrder
      op.startTime = this.formInline.createTime ? this.formInline.createTime[0] + ' 00:00:00' : ''
      op.endTime = this.formInline.createTime ? this.formInline.createTime[1] + ' 23:59:59' : ''
      this.$axios({
        url: _this.$API.customerManagement.queryOrderCustListByPage,
        // url: 'http://172.16.9.104:5010/agw/orderCustCtr/queryOrderCustListByPage',
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableList = response.data.resData.resultList
        _this.totalRows = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.query()
    let op = {}
    let _self = this
    op.pageNum = 1
    op.pageSize = 0
    this.$axios({
      url: _self.$API.customerManagement.queryHardProdByPage,
      // url: 'http://172.16.9.132:5010/agw/hardProdCtr/queryHardProdByPage',
      method: 'post',
      data: op
    }).then((response) => {
      _self.proData = response.data.resData.resultList
    }).catch((err) => {
      console.log(err)
    })
    this.$store.dispatch('getSystem') // 请求业务系统
    /* 查询支付渠道列表 */
    this.$axios
      .get(this.$API.pay.queryPayChannelList, {})
      .then(function (r) {
        _self.payChannelData = r.data.resData.channelList
      })
      .catch(function (error) {
        console.log(error)
      })
    /* 查询客户名称列表 */
    this.$axios
      .post(this.$API.rechargeManagement.queryCustSimpleInfoList, {})
      .then(function (r) {
        _self.custSimpleInfoList = r.data.resData
        _self.custCopeSimpleInfoList = r.data.resData
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
</style>



// WEBPACK FOOTER //
// src/views/cusOrderManagement/cusOrder.vue